// Pink Feminine Theme Color Tokens
// Single source of truth for all color values used in inline styles

export const colors = {
  // Backgrounds
  bg: '#FFF5F7',              // Very light blush - app background
  surface: '#FFE8ED',         // Light baby pink - cards/surfaces
  surfaceAlt: '#FFD6E0',      // Slightly deeper - section containers
  
  // Primary Colors
  primary: '#FF69B4',         // Vibrant pink - primary CTAs, buttons, active states
  primaryPressed: '#FF4DA6',  // Darker pink - pressed button state
  primaryHover: '#FF7BC4',    // Hover state
  primaryLight: '#FF8CC8',    // Lighter pink variant
  
  // Secondary Colors
  secondary: '#FFB6D1',       // Pastel pink - secondary actions, chips
  
  // Borders
  border: '#FFD0D9',         // Subtle pink-gray borders
  borderLight: '#FFE0E6',    // Lighter borders
  
  // Text Colors
  textPrimary: '#1A0A0E',     // Near-black for readability on light backgrounds
  textSecondary: '#5A3A45',   // Dark gray-pink for secondary text
  textTertiary: '#8A6A75',   // Muted pink-gray for tertiary text
  textOnPrimary: '#FFFFFF',   // White text on primary buttons
  
  // Icons & Accents
  icon: '#FF69B4',           // Icon color (matches primary)
  iconInactive: '#8A6A75',   // Inactive icon color
  
  // Status Colors
  success: '#4CAF50',         // Success states (kept green for readability)
  error: '#E91E63',          // Pink-red for errors (harmonized)
  warning: '#FF6B9D',        // Pink-orange for warnings
  
  // Nutrition Colors (harmonized with pink theme)
  calories: '#FFB347',       // Warm orange-pink for calories
  protein: '#FF69B4',        // Primary pink for protein
  carbs: '#FF8CC8',          // Light pink for carbs
  fat: '#FF6B9D',            // Pink-red for fat
  
  // Shadows & Overlays
  overlay: 'rgba(0, 0, 0, 0.5)',           // Modal overlays
  overlayLight: 'rgba(0, 0, 0, 0.3)',      // Light overlays
  shadowPrimary: 'rgba(255, 105, 180, 0.3)', // Pink glow shadow
  shadowPrimaryLight: 'rgba(255, 105, 180, 0.2)', // Light pink glow
  
  // Focus & Selection
  focusRing: 'rgba(255, 105, 180, 0.4)',    // Focus ring color
  selection: 'rgba(255, 105, 180, 0.15)',   // Selection background
};

